/* eslint-disable no-console */
import moment from 'moment';

// import {months} from '../../constants/Common';
import {financialYear as IFYear} from '../../interface/Units';
import useCompanyStore from '../../store/companyStore/companyDetailsStore';

import {ISelect} from './../../interface/ISelect';

export const yearSelect = (pfinancialYear?: string): ISelect[] => {
  const {preUnits} = useCompanyStore.getState();
  const yearValue = pfinancialYear ?? preUnits?.financialYear?.valueOf();

  const type = yearValue === IFYear?.JanDec?.valueOf() ? 'single' : 'double';

  const monthStart: string =
    yearValue?.valueOf().match(/[A-Z][a-z]+/g)?.[0] ?? 'Apr';

  const monthIndex = Number(moment().month(monthStart).format('M')) - 1;

  const monthReq = type === 'single' ? 0 : monthIndex;
  const isNewFinancialYear = moment().month() >= monthReq;
  const currentYear = moment().year();

  const result = [];
  const startYear = moment('01/01/2000').year();
  const endYear = isNewFinancialYear ? currentYear + 1 : currentYear;

  for (let year = startYear; year <= endYear - 1; year++) {
    if (type === 'double') {
      result.push({value: `${year}-${year + 1}`, label: `${year}-${year + 1}`});
    } else {
      result.push({value: `${year}`, label: `${year}`});
    }
  }

  return result.reverse();
};
